<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p3YApp/tc-custom/9781908117984.jpg?1706098014308" alt="This image is the cover for the book Luftwaffe Fighter Pilot"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Luftwaffe Fighter Pilot
      </h1>
      <p class="bookDescription body article font2">
        <b>A Nazi Germany fighter pilot gives readers a bird's-eye view from the cockpit of aerial combat against the Allied forces in World War II.</b><br/><br/> Within weeks of war being declared, Wolfgang Fischer had volunteered to join the Luftwaffe and spent nearly five of the succeeding six years of hostilities in uniform. During this time he was given a succession of postings varying from a long-range recce unit; as a decoder in a met office in occupied France; to a bomber squadron; and as a flying instructor, before joining a squadron of the famous Richthofen Geschwader in Italy, from where he was shot down in his FW 190 by Mustangs en route to Normandy.<br/><br/> By now a Lieutenant, he survived to fly offensive rocket attacks over Gold Beach on D-Day, only to be shot down again on D+1, and captured and sent first to a hospital in the UK, then into captivity in the USA. He was finally repatriated in April 1946. His description of all these events is entertaining and well-written, ranging from comic to tragic. It is unique in flavor, giving a valuable insight into the undeniably typical lot of those serving in the air arm of the Third Reich. Expertly translated and edited by John Weal, this is a worthy accompaniment to Norbert Hannig's <i>Luftwaffe Fighter Ace</i> published by Grub Street in 2004.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wolfgang Fischer, John Weal
      </h2>
      
      <p class="authorDescription body article">Wolfgang Fischer (11 December 1888 &ndash; 1 February 1943) was a German career military officer and panzer commander in World War II</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2295008a